import { Typography } from "@mui/material";
import { useMemo } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { useLocale } from "../../providers/LocaleProvider";

const ImportTasksErrorDialog = (props: any) => {
  const { theme, onClose, open = false, tasks = [], description } = props;
  const { translate } = useLocale();

  const isMultipleTasks = useMemo(() => tasks.length > 1, [tasks]);

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("settings.importTasks")}
      actions={[
        {
          label: translate("common.cancel"),
          primary: true,
          variant: "filled",
          disabled: false,
          onClick: onClose
        }
      ]}
    >
      <Typography>
        {description ||
          translate(
            isMultipleTasks
              ? "settings.importTasksErrorMultiple"
              : "settings.importTasksErrorSingle"
          )}
      </Typography>

      <ul>
        {tasks.map((task: any) => (
          <li key={task.id}>
            <Typography>{task.name}</Typography>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};

export default ImportTasksErrorDialog;
